import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {
  TouchableOpacity,
  Text,
  StyleProp,
  Image,
  ImageSourcePropType,
} from 'react-native';
import styleSheet from './styles';

export interface PillButtonProps {
  onPress: () => void;
  image: ImageSourcePropType;
  backgroundColor?: string;
  title?: string;
  textStyle?: StyleProp<any>;
  children?: JSX.Element;
}

const PillButton = (props: PillButtonProps) => {
  const styles = styleSheet(useTheme());

  return (
    <TouchableOpacity
      style={[
        styles.container,
        {
          ...(props.backgroundColor && {
            backgroundColor: props.backgroundColor,
          }),
        },
      ]}
      onPress={props.onPress}>
      <Image source={props.image} style={styles.image} />
      <Text style={props.textStyle}>{props.title}</Text>
      {props.children}
    </TouchableOpacity>
  );
};

export default PillButton;
